/**
 * A HOC wrapping material UIs linear progress bar, shown when fetching data in
 * our tables
 */
import React from 'react';
import { LinearProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = () => ({
  root: {
    height: '5px',
    width: '100%',
  },
  linearColorPrimary: {
    backgroundColor: 'none',
  },
  linearBarColorPrimary: {
    backgroundColor: '#42A5F5',
  },
});

export default withStyles(
  ({ classes, loading }) => (
    <div className={classes.root}>
      {loading && (
        <LinearProgress
          classes={{
            colorPrimary: classes.linearColorPrimary,
            barColorPrimary: classes.linearBarColorPrimary,
          }}
        />
      )}
    </div>
  ),
  styles,
);
